import { gsap }             from "gsap";
import { ScrollTrigger }    from "gsap/ScrollTrigger";
import videoVimeo         from "./videoVimeo";

gsap.registerPlugin(ScrollTrigger);


let animMarque = {
    tl: [],
    init() {
        if($('body').hasClass('page-node-type-marque')){
            this.header();
        }
    },


    header() {
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: '.content-top',
                start: 'top top',
                end: 'bottom top',
                scrub: 1,
                pin: true,
                toggleActions : 'play none none reverse',
                markers: false,
            }
        })
        tl.to(".top .bg-anim", {duration: 0.2, opacity: 1}, 0);
        tl.to(".top .bg-anim", {duration: 1, y: '-100vh'}, 0.2);
        tl.to(".bloc-text-fond", {duration: 1, y: '-100vh'}, 0.2);
        tl.to(".bloc-pictos-cadre", {duration: 1, 'margin-top': '-100vh'}, 1);

    }

}

export default animMarque;
